import {useMutation} from 'react-query';
import {
  PUBLIC_KLAVIYO_API_KEY,
  PUBLIC_KLAVIYO_COMPANY_ID,
} from '~/utils/constants';

interface MutationProps {
  email: string;
}

export function useSubscribe() {
  const {mutateAsync, ...props} = useMutation(
    async ({email}: MutationProps) => {
      //TODO: Should be doing this from server function so that we don't leak klaviyo api key
      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${PUBLIC_KLAVIYO_COMPANY_ID}`,
        {
          method: 'POST',
          headers: {
            revision: '2022-10-17',
            'content-type': `application/json`,
            Authorization: `Klaviyo-API-Key ${PUBLIC_KLAVIYO_API_KEY}`,
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: 'Y9CP3G',
                email,
              },
            },
          }),
        },
      );

      if (res.status != 202) {
        return JSON.stringify({
          error: false,
          message: 'OK',
          data: res.json(),
        });
      }

      return JSON.stringify({
        error: false,
        message: 'OK',
        data: null,
      });
    },
  );

  return {subscribe: mutateAsync, ...props} as const;
}
